export default "__VITE_ASSET__DID98JJa__"